import styled from '@emotion/styled';
import { breakpoints } from '~/theme/breakpoints';
import { theme } from '~/theme';
import { keyframes } from '@emotion/react';
import { mq } from '~/lib/helpers/media-query.helper';
import { StyledCloseIcon } from '~/features/productList/components/FilterBar/SelectedFacets/SelectedFacets.styles';

export const StyledMiniBasketWrapper = styled.div(() => ({
    display: 'block',
    alignSelf: 'center',
    height: '100%',
}));

export const StyledMiniBaskedHeader = styled.div(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    borderBottom: `1px solid ${theme?.colors.brownLight}`,
    top: 0,
    padding: theme.space['3'],
    ...theme.mixins.useTextStyle('InfoHeader'),
}));

export const StyledMiniBasketContent = styled.div(() => ({
    animation: `${fadeIn} 0.3s ease-in-out`,
    alignItems: 'center',
    boxShadow: theme?.shadows.productCard,
    height: '100%',
    width: '100%',
    zIndex: theme.zIndices.max,

    background: theme.colors.white,
    display: 'flex',
    flexDirection: 'column',
    [breakpoints.md]: {
        position: 'unset',
        width: '100%',
    },
    [breakpoints.sm]: {
        height: '100%',
    },
}));

export const StyledMiniBaskedMainTitle = styled.div(() => ({
    fontWeight: theme.fontWeights.medium,
    display: 'flex',
    alignItems: 'center',
    flex: 1,

    '& :first-child': {
        marginRight: theme.space[2],
    },
}));

export const StyledProgressBarWrapper = styled.div(() => ({
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    borderTop: `1px solid ${theme.colors.brownLight}`,
    borderBottom: `1px solid ${theme.colors.brownLight}`,
    justifyContent: 'center',
    minHeight: theme.space['7'],
    overflow: 'hidden',
    flexDirection: 'column',
    padding: `0 ${theme.space['6']}`,
    h3: {
        marginBottom: theme.space['1'],
        fontSize: theme.fontSizes['sm'],
        fontWeight: theme.fontWeights.light,
        textTransform: 'none',
    },
    '> div': {
        height: theme.space['1'],
    },

    [breakpoints.md]: {
        minHeight: theme.space['7'],
        display: 'flex',
    },
}));

export const StyledProductItemWrapper = styled.div(() => ({
    minHeight: 150,
    height: 150,
    width: '100%',
    ':has(:focus-visible)': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const StyledProductItem = styled.div(() => ({
    '& a:hover': {
        textDecoration: 'none',
    },

    borderBottom: `1px solid ${theme?.colors.brownLight}`,
    width: '100%',
    display: 'flex',
    height: '100%',
    zIndex: 1,
    transitionDuration: '150ms',
    transitionProperty: 'transform',
    transitionTimingFunction: 'ease-in',
    [mq(0, 'xs')]: {
        flexDirection: 'column',
    },
}));

export const StyledMiniBasketImageWrap = styled.div(() => ({
    height: '100%',
    width: '150px',
    background: theme.colors.productImageBackround,
    position: 'relative',
    img: {
        mixBlendMode: 'multiply',
    },

    [breakpoints.lg]: {
        height: '100%',
        width: '126px',
    },
    [mq(0, 'xs')]: {
        height: '150px',
        width: '100%',
    },
}));

export const StyledMiniBaskedProductInfo = styled.div(() => ({
    position: 'relative',
    width: '100%',
    padding: theme.space['3'],
    display: 'grid',
    gap: theme.space['2'],
    gridTemplateColumns: '1fr auto auto',
    gridTemplateAreas: `
        'product-info-details product-info-details remove-product-button'
        'price-per-item input-stepper input-stepper'
        'product-price product-price product-price'
        `,
    justifyContent: 'space-between',
}));

export const StyledMiniBasketProductInfoDetails = styled.div(() => ({
    gridArea: 'product-info-details',
}));

export const StyledMiniBasketProductInfoBrand = styled.span(() => ({
    color: theme.colors.black,
    fontSize: theme.fontSizes['2xs'],
    lineHeight: theme.fontSizes['2xs'],
    fontWeight: theme.fontWeights.medium,
    [breakpoints.md]: {
        fontSize: theme.fontSizes['xs'],
    },
}));
export const StyledMiniBasketProductInfoTitle = styled.p(() => ({
    color: theme.colors.black,
    fontSize: theme.fontSizes['xs'],
    lineHeight: theme.lineHeights.base,
    fontWeight: theme.fontWeights.medium,
    [breakpoints.md]: {
        fontSize: theme.fontSizes['sm'],
    },
}));

export const StyledMiniBasketCloseWrapper = styled.div(() => ({
    display: 'flex',
    alignItems: 'center',
}));

export const StyledMiniBasketCloseIcon = styled(StyledCloseIcon)(() => ({
    width: 15,
    height: 15,
    marginLeft: theme.space['2'],
    marginTop: 2,
    cursor: 'pointer',
    padding: 0,
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const StyledMiniBasketCTAWrapper = styled.div(() => ({
    padding: theme.space[4],
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    [breakpoints.xs]: {
        padding: `${theme.space[4]} ${theme.space[3]}`,
    },
}));

export const StyledMiniBasketSimpleListWrapper = styled.div(() => ({
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    padding: `0 ${theme.space[2]}`,
    backgroundColor: theme.colors.brownLight,
    height: '100%',
    width: '100%',
    paddingTop: theme.space['3'],
    [mq(0, 'sm')]: {
        paddingBottom: theme.space['6'],
    },
}));

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
